/* src/app/price-list/partials/price-list-form/price-list-form.component.scss */
/*# sourceMappingURL=price-list-form.component.css.map */
